import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import userProgressMixin from '../../mixins/_user_progress';

/**
 * アイテム登録完了モーダル
 */
export default {
    name: 'modalItemDeployed',
    template: '#modal_item_deployed_component_template',
    data() {
        return {
            item_code: '',
            // guide_step完了フラグ
            finished: true,
        };
    },
    props: {
        // 反映方法
        deploy_mode: {
            type: String,
            default: 'normal',
            validator: function (value) {
                return ['normal', 'reserve', 'private'].includes(value);
            },
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        userProgressMixin,
    ],
    computed: {
        itemPageURL: function () {
            return this.$_yahooPageUrl(this.item_code);
        },
        // 反映モードに応じたテキスト
        deployInfo: function () {
            switch (this.deploy_mode) {
                case 'normal':
                    return 'ストアへの反映には、数十分のタイムラグがあります。';
                case 'reserve':
                    return 'ストアへの反映は、指定した日時に行われます。';
                case 'private':
                    return 'ストアには反映されません。ストアクリエイターProにてご反映をお願いします。';
            }
        }
    },
    methods: {
        // 商品一覧に戻る
        listItemPage: function() {
            window.location.href = '/item';
            this.close();
        },
        // アイテム登録完了モーダルを開く
        itemDeployed: async function(item_code){
            this.$_loading();
            this.finished = await this.isDoneTask('opening', 'item');
            // opening.item'が未完了なら完了フラグを立てる
            if (!this.finished) {
                await this.updateUserProgress('opening', 'item');
            }
            this.$_unloading();
            this.item_code = item_code;
            this.open();
        },
        // 開店までのガイドページへ戻る
        guideOpeningsPage: async function () {
            window.location.href = '/build_store';
        },
        // 商品編集ページへ戻る
        itemEditPage: function () {
            window.location.href = '/item/edit?item_code=' + this.item_code;
        },
        // ストアクリエイター商品編集ページへ
        storeCreatorEditPage: function () {
            const url = this.config.store_creator_editor_url + 'RT/' + this.config.user.shop_id + '/PageEdit/index?page_key=' + this.item_code + '&page_mode=Edit';
            window.open(url, '_blank');
        },
        // 商品ページへ
        itemPage: function(){
            window.open(this.itemPageURL, '_blank');
        }
    }
}; 